<!-- 网站首页 -->
<template>
  <transition name="el-fade-in">
    <div v-if="show" @scroll.prevent @touchmove.prevent @click="click_close" class="page_content p_flex p_justify_center p_align_items">
      <slot></slot>
    </div>
  </transition>
</template>
<script>
  export default {

    data() {
      return {}
    },
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      click_close(){
        this.$emit('callback',false)
      }
    }
  }
</script>

<style scoped="scoped">
  .page_content {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    background-color: rgba(0, 0, 0, .5);
  }
</style>



// WEBPACK FOOTER //
// src/components/public-popup/public-popup.vue